import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import _ from 'lodash'
import FileSaver from 'file-saver'
import { useTranslation } from 'react-i18next'
import momenttz from '../../helpers/momenttz'

import { defaultTableOptions } from '../../helpers/table'

import { apiCallGet } from '../../../action/RouterActions'
import { formatTimestamp } from '../../helpers/tablesFuncHelpers'
import CustomButton from '../../CustomButton'
import CalendarDropdown from "../CalendarDropdown"

const ModalDeviceConfigAuditLog = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'modals.modalDeviceConfigAuditLog' });
	const { device, toggleLoaderModal, loaderModal } = props;

	const [auditLogs, setAuditLogs] = useState([]);
	const [start_date, setStart_date] = useState(moment().subtract(4, 'days').format("YYYYMMDD"));
	const [end_date, setEnd_date] = useState(moment().format("YYYYMMDD"));

	useEffect(() => {
		getConfigAuditLog();
	}, []);

	const getConfigAuditLog = () => {
		toggleLoaderModal(true);

		let data = {
			start_ts: momenttz(moment(start_date).format('YYYY-MM-DD 00:00:00')).utc().format('YYYYMMDDHHmmss'),
			end_ts: momenttz(moment(end_date).format('YYYY-MM-DD 23:59:59')).utc().format('YYYYMMDDHHmmss'),
			device_id: device.device_id,
		}

		apiCallGet(`/devices/${device.device_id}/config_history`, data)
			.then((res, err) => {
				toggleLoaderModal(false)
				const response = res.data.response
				setAuditLogs(response.logs);
			})
			.catch((error) => {
				toggleLoaderModal(false)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const startDateChanged = (current) => {
		setStart_date(moment(current).format('YYYYMMDD'));
	}

	const endDateChanged = (current) => {
		setEnd_date(moment(current).format('YYYYMMDD'));
	}

	const downloadConfig = (id) => {
		toggleLoaderModal(true);
		apiCallGet(`/devices/config_history/${id}/file`)
			.then((res, err) => {
				toggleLoaderModal(false);
				let file = res.data;
				let blob = new Blob([file], { type: 'text/plain;charset=utf-8' });
				FileSaver.saveAs(blob, 'config.txt');
				toastr.success('Success', t('fileDownloaded'));
			})
			.catch((error) => {
				toggleLoaderModal(false);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const formatDownloadConfig = (cell, row) => {
		return (
			<CustomButton
				variant="link"
				onClick={() => downloadConfig(cell)}
				tdStyle={{ textAlign: 'center' }}
			>
				{t('btnDownloadConfig')}
			</CustomButton>)
	}

	return (
		<Modal
			size='xl'
			show
			onHide={props.onHide}
			aria-labelledby="contained-modal-title-lg"
			dialogClassName="modal-audit-lg"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">{t('titleConfigAuditLog')} - {device.vehicle_name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-audit-log audit-view-modal">
					<div className="row reload-dates-mobile" style={{ display: 'flex' }}>
						<div className="col-md-4 date-container">
							<div className="date"><span>{t('titleStartDate')}</span></div>
							<div className="datetime">
								<CalendarDropdown
									date={moment(start_date)}
									onChange={startDateChanged}
								/>
							</div>
						</div>
						<div className="col-md-4 date-container">
							<div className="date"><span>{t('titleEndDate')}</span></div>
							<div className="datetime">
								<CalendarDropdown
									date={moment(end_date)}
									onChange={endDateChanged}
								/>
							</div>
						</div>
						<div className="col-md-4" style={{ paddingTop: '5px', paddingBottom: '5px' }}>
							<CustomButton
								onClick={getConfigAuditLog}
								variant="primary-outline"
							>
								{t('btnReload')}
							</CustomButton>
						</div>
					</div>
				</div>

				<div className="manage-users-table audit-view-page-table" style={{ clear: 'both', marginTop: '20px' }}>
					<BootstrapTable
						data={auditLogs}
						{...defaultTableOptions}
					>
						<TableHeaderColumn
							isKey
							width="20%"
							dataField="timestamp"
							dataFormat={formatTimestamp}
						>
							{t('titleDate/Time')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="25%"
							dataField="profile_name"
						>
							{t('titleProfileName')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="25%"
							dataField="user_name"
						>
							{t('titleLastUpdatedBy')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="25%"
							dataField="id"
							dataFormat={formatDownloadConfig}
							tdStyle={{ textAlign: 'center' }}
						>
							{t('titleConfigFilePushed')}
						</TableHeaderColumn>
					</BootstrapTable>
				</div>
			</Modal.Body>
			{loaderModal}
		</Modal>
	)
}

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(ModalDeviceConfigAuditLog);
